<template>
  <div class="mod-trade__agreement}">
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @selection-change="dataListSelectionChangeHandle"
      style="width: 100%"
      :max-height="maxTableHeight"
    >
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
        label="行号"
      ></el-table-column>
      <el-table-column
        prop="code"
        label="品番号"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div>品番号：{{ scope.row.code }}</div>
          <div v-if="scope.row.skuCode">SKU编号：{{ scope.row.skuCode }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="产品名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="size"
        label="尺寸"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="count"
        label="数量"
        header-align="center"
        align="center"
      >
      <template slot-scope="scope">
        <div>合同数量：{{scope.row.count}}</div>
        <div>完成数量：{{scope.row.completeCount}}</div>
      </template>
      </el-table-column>
      <el-table-column
        prop="boxCount"
        label="每箱入数"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column label="单价" header-align="center" align="center">
        <template slot-scope="scope">
          {{ moneyFormat(scope.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('handle')"
        header-align="center"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  components: {  },
  props: {
    parentId: {
      type: String,
      default: "",
    },
    maxTableHeight: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      statusType: {
        10: "",
        20: "warning",
        30: "success",
      },
      mixinViewModuleOptions: {
        getDataListURL: "/trade/agreement/detail/list",
        getDataListIsPage: false,
        deleteIsBatch: true,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: "",
      },
    };
  },
  watch: {
    parentId: {
      handler: function (newVal) {
        if (!newVal) {
          this.dataList = [];
          return;
        }
        this.dataForm.agreementId = newVal;
        this.getDataList();
      },
      immediate: true,
    },
  },
  methods: {
  },
};
</script>
